// @flow

import _ from 'lodash';

/**
 * Class used for the payment statistics graph.
 */
export default class PaymentStatsGraphInfo {

  // the date of the day as a timestamp in milliseconds.
  day:number = 0;

  // the total of all the payments for the day (tips include)
  total:number = 0;

  constructor(day:string, total:number) {
    this.day = Number(day) * 1000;
    if (!_.isNaN(total)) {
      this.total = total;
    } else {
      // cf PaymentStatGraph occurred when multiple payins of same bill have different date.
      console.error('PaymentStatsGraphInfo total is nan for day', day, total);
    }
  }

}
